<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showAddEventDialog"
      @searchList="getEventList"
      @batchDelEvent="onBatchDelEvent"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="idFlag"
          prop="id"
          label="id"
          align="left"
        ></el-table-column>
        <!-- <el-table-column type="selection" align="left"></el-table-column> -->
        <el-table-column
          v-if="idFlag"
          prop="courseId"
          label="courseId"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="stdName"
          label="学员名称"
          align="left"
        ></el-table-column>
        <el-table-column prop="eventDate" label="日期" align="left" sortable>
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.eventDate | filterTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="eventContent"
          label="事件内容"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="eventType"
          label="事件类型"
          align="left"
          :filters="fields.eventType.filter.list"
          :filter-method="filterEventType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterEventType(scope.row)"
              disable-transitions
              >{{ scope.row.eventType }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="eventNote"
          label="事件备注"
          align="left"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditStudent(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteEvent(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addEventDialog.show"
        :isShow="addEventDialog.show"
        :dialogRow="addEventDialog.dialogRow"
        :stdName="addEventDialog.stdName"
        @getEventList="getEventList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addEventDialog";
import { formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import { getEventInfo, deleteEvent, batchDeleteEvent } from "@/api/event";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_event_type_list: {
        0: "自编",
        1: "自动",
        2: "候补",
        3: "取消",
        4: "上课",
        5: "预约",
        6: "登记",
      },
      addEventDialog: {
        show: false,
        dialogRow: {},
        stdName: "",
      },
      eventData: {
        page: 1,
        limit: 20,
      },
      studentData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {
        eventType: {
          filter: {
            list: [
              {
                text: "自编",
                value: 0,
              },
              {
                text: "自动",
                value: 1,
              },
              {
                text: "候补",
                value: 2,
              },
              {
                text: "取消",
                value: 3,
              },
              {
                text: "上课",
                value: 4,
              },
              {
                text: "预约",
                value: 5,
              },
              {
                text: "登记",
                value: 6,
              },
            ],
          },
        },
      },
    };
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["eventSearch"]),
  },
  filters: {
    filterTime(time) {
      //var dd = myTime(time);
      return formatDateTime(time);
    },
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取事件列表数据
    getEventList() {
      console.log(this.eventData);
      console.log();
      const para = Object.assign({}, this.eventData, this.eventSearch);
      console.log(para);
      getEventInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.eventData;
      });
    },
    // 显示资金弹框
    showAddEventDialog(val) {
      this.$store.commit("SET_EVENT_DIALOG_TITLE", val);
      this.addEventDialog.show = true;
    },
    hideAddFundDialog() {
      this.addEventDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.eventData.page = val;
      this.getEventList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.eventData.limit = val;
      this.getEventList();
    },
    /**
     * 格式化状态
     */
    formatterEventType(item) {
      const type = parseInt(item.eventType);
      return this.format_event_type_list[type];
    },
    filterEventType(value, item) {
      const type = parseInt(item.eventType);
      return (
        this.format_event_type_list[value] == this.format_event_type_list[type]
      );
    },
    // 编辑操作方法
    onEditStudent(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      this.addEventDialog.dialogRow = { ...row };
      this.addEventDialog.stdName = row.stdName;
      this.showAddEventDialog();
    },
    // 删除数据
    onDeleteEvent(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          console.log(para);
          let eventContent = row.eventContent;
          let eventType = this.format_event_type_list[parseInt(row.eventType)];
          let eventDate = row.eventDate;
          deleteEvent(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:
                "删除学员(" +
                row.stdName +
                ")事件操作,事件内容:" +
                eventContent +
                ",事件类型:" +
                eventType +
                ",事件日期:" +
                eventDate,
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getEventList();
          });
        })
        .catch(() => {});
    },
    onBatchDelEvent() {
      // console.log("onbatchdelmember");
      this.$confirm("确认批量删除记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id).toString();
          const para = { ids: ids };
          batchDeleteEvent(para).then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "批量删除成功",
                type: "success",
              });
              this.getEventList();
            }
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_EVENT_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>